import React from 'react';

import { SPACE_PERMISSIONS_SETTINGS } from '@confluence/named-routes';
import { useRouteName } from '@confluence/route-manager/entry-points/RouteState';
import { FeedbackCollectorButton } from '@confluence/space-roles/entry-points/FeedbackCollector';

export const SpaceAccessFeedbackButton = () => {
	const isSpacePermissionsPageArgs = {
		selector: (routeName: string | undefined) => {
			if (!routeName) {
				return false;
			}
			return routeName === SPACE_PERMISSIONS_SETTINGS.name;
		},
	};
	const isSpacePermissionsPage = useRouteName(isSpacePermissionsPageArgs);

	if (!isSpacePermissionsPage) {
		return null;
	}

	return <FeedbackCollectorButton source="Space Access" />;
};
